import React from 'react';

export default function Pricing() {
  return (
    <section id="packages" className="py-24 px-6 relative">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-instrument italic text-3xl md:text-5xl text-white">
            "Simple pricing. <br className="md:hidden" /> No agency games."
          </h2>
          <p className="text-white/50 font-sans text-sm mt-3">
            Intro rate available for first 3 bookings.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 font-sans">
          {/* Card 1 */}
          <div className="liquid-glass rounded-2xl p-8 flex flex-col items-center text-center border border-white/5">
            <h3 className="text-white/60 text-sm font-semibold tracking-wider uppercase">CORE</h3>
            <div className="text-white text-4xl font-bold mt-2 mb-6">$850</div>
            
            <hr className="w-full border-t border-white/20 mb-6" />
            
            <ul className="text-white/80 space-y-3 mb-8 flex-1 text-sm">
              <li>1 Amazon listing video</li>
              <li>30–45 seconds</li>
              <li>2 revision rounds</li>
              <li>7-day turnaround</li>
            </ul>

            <hr className="w-full border-t border-white/20 mb-6" />
            
            <a 
              href="https://portal.wearesanstitre.com/catalog/amazon-product-video" 
              target="_blank" 
              rel="noopener noreferrer"
              className="block w-full border border-white/40 text-white rounded-full py-3 hover:bg-white hover:text-black transition-colors font-medium"
            >
              Book Core &rarr;
            </a>
            <p className="font-sans text-white/40 text-xs text-center mt-3">
              + Add 5 product photos — $300
            </p>
          </div>

          {/* Card 2 - Featured */}
          <div className="liquid-glass rounded-2xl p-8 flex flex-col items-center text-center border border-white/20 [background:rgba(255,255,255,0.05)] shadow-2xl">
            <h3 className="text-white/90 text-sm font-semibold tracking-wider uppercase">GROWTH</h3>
            <div className="text-white text-4xl font-bold mt-2 mb-6">$1,650</div>
            
            <hr className="w-full border-t border-white/20 mb-6" />
            
            <ul className="text-white/80 space-y-3 mb-8 flex-1 text-sm">
              <li>Everything in Core</li>
              <li className="text-white">+ 4 platform cutdowns</li>
              <li className="text-white/50 text-xs">TikTok · Reels · Meta</li>
              <li>2 revision rounds</li>
              <li>7-day turnaround</li>
            </ul>

            <hr className="w-full border-t border-white/20 mb-6" />
            
            <a 
              href="https://portal.wearesanstitre.com/catalog/amazon-product-video" 
              target="_blank" 
              rel="noopener noreferrer"
              className="block w-full bg-white text-black rounded-full py-3 hover:bg-white/90 transition-colors font-medium"
            >
              Book Growth &rarr;
            </a>
            <p className="font-sans text-white/40 text-xs text-center mt-3">
              + Add 10 brand photos — $500
            </p>
          </div>

          {/* Card 3 */}
          <div className="liquid-glass rounded-2xl p-8 flex flex-col items-center text-center border border-white/5">
            <h3 className="text-white/60 text-sm font-semibold tracking-wider uppercase">CUSTOM</h3>
            <div className="text-white text-3xl font-bold mt-2 mb-6">Let's Talk</div>
            
            <hr className="w-full border-t border-white/20 mb-6" />
            
            <ul className="text-white/80 space-y-3 mb-8 flex-1 text-sm">
              <li>Models & talent</li>
              <li>On-location shoots</li>
              <li>Multi-product campaigns</li>
              <li>Full creative direction</li>
            </ul>

            <hr className="w-full border-t border-white/20 mb-6" />
            
            <a 
              href="#cta" 
              className="block w-full border border-white/40 text-white rounded-full py-3 hover:bg-white hover:text-black transition-colors font-medium"
            >
              Contact Me &rarr;
            </a>
            <p className="font-sans text-white/40 text-xs text-center mt-3">
              Photo packages available — ask us
            </p>
          </div>
        </div>

        <div className="mt-12 text-center text-white/40 text-xs font-sans flex flex-wrap justify-center gap-2 sm:gap-4 uppercase tracking-wider">
          <span>Add Digital Ad Rights +$400</span>
          <span className="hidden sm:inline">·</span>
          <span>Full Digital Rights +$650</span>
          <span className="hidden sm:inline">·</span>
          <span>Broadcast — Contact</span>
        </div>
      </div>
    </section>
  );
}